import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import styles from './styles.module.scss';

const Micro = (props) => (
  <span {...props} className={cn(styles.micro, props.className)} />
);

Micro.propTypes = {
  className: PropTypes.string,
};

Micro.defaultProps = {
  className: '',
};
export default Micro;
